/**
 * How long the splash stays up.
 *
 * Two conditions, both of which must be met: the session has been read from
 * storage, and the splash has been visible long enough to be seen rather than
 * flickering past. Without the floor, a warm start on a fast device shows the
 * artwork for a single frame, which reads as a glitch.
 */

import { useEffect, useState } from 'react';

import { useAuthLoading } from '../../core/auth/useAuth';

/** Minimum time the artwork stays on screen, in milliseconds. */
export const SPLASH_MIN_MS = 1400;

export function useSplashHold(): boolean {
  const authLoading = useAuthLoading();
  const [floorElapsed, setFloorElapsed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setFloorElapsed(true), SPLASH_MIN_MS);
    return () => clearTimeout(timer);
  }, []);

  return authLoading || !floorElapsed;
}
